import React, { useEffect, useState } from "react";
import { PostEmailFooter } from "../apis/post";
import { GetEmailFooter } from "../apis/get";


interface User {
  senderName: string;
  groupName: string;
  contact: string;
  senderEmail: string;
  senderDesignation: string;
}

const EditableJsonViewer: React.FC = () => {
  // Initial JSON data
  const initialJson: User = {
    senderName: "",
    groupName: "",
    contact: "",
    senderEmail: "",
    senderDesignation: ""
  };

  // State to store the editable JSON
  const [jsonData, setJsonData] = useState<User>(initialJson);
  const [isEditing, setIsEditing] = useState<boolean>(false); // Flag to toggle edit mode

  const getAndSetEmailFooterData = async () => {
    const res = await GetEmailFooter()
    if (res.status) {
      setJsonData(res.data)
    }
    
  }

  useEffect(() => {
    getAndSetEmailFooterData()
  }, [false])

  // Handle editing of JSON data
  const handleEdit = (key: string, value: string) => {
    const updatedJson = { ...jsonData, [key]: value };
    setJsonData(updatedJson);
  };

  // Handle saving the updated JSON
  const handleSave = async () => {
    try {
      JSON.parse(JSON.stringify(jsonData)); // Ensure valid JSON
      const res = await PostEmailFooter(jsonData)
      setIsEditing(false); // Turn off editing mode if JSON is valid
    } catch (error) {
      alert("Invalid JSON format.");
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-black bg-opacity-40 backdrop-blur rounded-2xl shadow-2xl text-white mt-8 mb-8">
      <h1 className="text-2xl font-semibold mb-4 text-yellow-300">Editable JSON Viewer</h1>

      {/* Show JSON in a text area when editing */}
      {isEditing ? (
        <textarea
          value={JSON.stringify(jsonData, null, 2)} // Pretty print JSON
          onChange={(e) => setJsonData(JSON.parse(e.target.value))}
          rows={15}
          className="w-full p-3 border border-gray-300 rounded-md bg-gray-800 text-white font-mono"
        />
      ) : (
        <pre className="w-full p-3 border border-gray-300 rounded-md bg-gray-800 text-white font-mono">
          {JSON.stringify(jsonData, null, 2)}
        </pre>
      )}

      {/* Buttons for toggling edit mode and saving */}
      <div className="mt-4 flex justify-between items-center">
        {isEditing ? (
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
          >
            Save Changes
          </button>
        ) : (
          <button
            onClick={() => setIsEditing(true)}
            className="px-4 py-2 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600"
          >
            Edit JSON
          </button>
        )}
        {/* <button
          onClick={() => setJsonData(initialJson)} // Reset to initial JSON
          className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
        >
          Reset
        </button> */}
      </div>
    </div>
  );
};

export default EditableJsonViewer;
